import type {SubmitEvent} from 'react'
import {useState} from 'react'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import ApiHelper from '@freckle/school/ts/common/helpers/api-helper'
import Notification from '@freckle/school/ts/common/helpers/notification'
import {ForgotPassword} from '@freckle/school/ts/pages/forgot-password/forgot-password'

export function ForgotPasswordContainer() {
  const {t} = useSafeTranslation()

  const [email, setEmail] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [showSuccess, setShowSuccess] = useState<boolean>(false)

  function onSubmitLogin(e: SubmitEvent<HTMLFormElement>) {
    e.preventDefault()

    const trimmedEmail = email.trim()

    if (trimmedEmail.length === 0) {
      Notification.displayErrorNotification(t('FORGOT_PASSWORD_INVALID_EMAIL_ERROR_TEXT'))
      return
    }

    setLoading(true)

    ApiHelper.sendEmailReset(trimmedEmail)
      .then(() => {
        setLoading(false)
        setShowSuccess(true)
      })
      .catch(() => {
        setLoading(false)
        Notification.displayErrorNotification(t('FORGOT_PASSWORD_ERROR_TEXT'))
      })
  }

  return (
    <ForgotPassword
      email={email}
      onChangeEmail={setEmail}
      onSubmitLogin={onSubmitLogin}
      loading={loading}
      showSuccess={showSuccess}
    />
  )
}
